import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomePageComponent } from './home-page/home-page.component';
import { IndividualPageComponent } from './individual-page/individual-page.component';
import { FormsModule } from "@angular/forms";
import { FooterComponent } from './components/footer/footer.component';
import { TypePageComponent } from './type-page/type-page.component';

@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    IndividualPageComponent,
    FooterComponent,
    TypePageComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
